import React from 'react'
import './index.less'

export default function Method(props) {
  const { currentTags } = props
  // console.log(currentTags, "method-currentTags")

  return (
    <div className='method-total'>
      <div className='method-wrapper'>
        {currentTags.map((item) => {
          return (
            <div className='method-tags' key={item}>
              {item}
            </div>
          )
        })}
      </div>
    </div>
  )
}
